import {
  Button,
  Flex,
  Icon,
  Spacer,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { IconType } from "react-icons/lib";

interface Props {
  totalItems?: number;
  pageSize?: number;
  index?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
  onPageChange: (page: number) => void;
}

export const PageChangeButtons = ({
  totalItems = 0,
  pageSize = 0,
  index = 0,
  hasPreviousPage = false,
  hasNextPage = false,
  onPageChange
}: Props) => {
  const item1 = totalItems > 0 ? index * pageSize + 1 : 0;
  const item2 = (index + 1) * pageSize;

  return (
    <Flex alignItems="flex-end" pl={4}>
      <Spacer />
      <Flex alignItems="center" justifyContent="flex-end">
        <Text fontSize="small" color="gray.500" mr="2">
          {item1} - {item2 >= totalItems ? totalItems : item2} de {totalItems}
        </Text>
        <Flex>
          <ChangeButtons
            active={hasPreviousPage}
            icon={FaAngleLeft}
            onPageChange={() => onPageChange(index - 1)}
          />
          <ChangeButtons
            active={hasNextPage}
            icon={FaAngleRight}
            onPageChange={() => onPageChange(index + 1)}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

interface ButtonProps {
  active: boolean;
  onPageChange: () => void;
  icon: IconType;
}

export const ChangeButtons = ({
  active = false,
  onPageChange,
  icon
}: ButtonProps) => {
  const disabledColor = useColorModeValue("gray.400", "gray.600");
  const activeColor = useColorModeValue("main.500", "main.500");

  return (
    <Button
      fontWeight="normal"
      fontSize={{ base: "1.5rem", lg: "1.2rem" }}
      px={{ base: "1rem", lg: "0.5rem" }}
      py={{ base: "1.3rem", lg: "0.5rem" }}
      size="sm"
      variant="ghost"
      disabled={!active}
      color={active ? activeColor : disabledColor}
      onClick={onPageChange}
      ml="2"
    >
      <Icon as={icon} />
    </Button>
  );
};
